// src/components/LoginButton.js
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@chakra-ui/react';
import { routes } from '../config/auth.config';

/**
 * Login button that redirects to Auth0 login page
 * Uses centralized config for redirect URI
 */
const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    try {
      await loginWithRedirect({
        appState: {
          returnTo: routes.dashboard,
        },
      });
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <Button colorScheme="teal" onClick={handleLogin}>
      Log In
    </Button>
  );
};

export default LoginButton;
